import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DecryptPipe } from '../shared/decrypt.pipe';
import { EncryptPipe } from '../shared/encrypt.pipe';
import * as CryptoJS from 'crypto-js';
import Cookies from 'js-cookie'
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class HttpService {
  API_URL = environment.API_URL;
  API_URL_V2 = environment.API_URL_V2;
  API_URL_WF = environment.API_URL_WF;
  bucketUrl = environment.bucketURL;
  
  constructor(private http: HttpClient, private decryptPipe: DecryptPipe, private encryptPipe: EncryptPipe, private toastr: ToastrService) { }
  getHeaders() {
    const token = this.localStorageGetItem('admin_token');
    const headers = {
      Authorization: `Bearer ${token}`,
      // 'Content-Type': 'application/json'
    };
    return headers;
  }

  isCompanyAdmin() {
    const user = JSON.parse(this.localStorageGetItem('admin_user'));
    if(user && user.role) return user.role == 'companyadmin';
    return false
  }

  apiGet(url) {
    return this.http.get(this.API_URL + url);
  }

  apiGetFile(url) {
    const headers = this.getHeaders();
    return this.http.get(this.API_URL + url, { headers, responseType: 'arraybuffer' });
  }

  apiGetProtected(url) {
    const headers = this.getHeaders();
    return this.http.get(this.API_URL + url, { headers });
  }

  apiGetProtectedWithParams(url, params) {
    const headers = this.getHeaders();
    return this.http.get(this.API_URL + url, { headers, params });
  }

  apiPost(url, data) {
    const headers = this.getHeaders();
    return this.http.post(this.API_URL + url, data, { headers });
  }

  apiPostV2(url, data) {
    const headers = this.getHeaders();
    return this.http.post(this.API_URL_V2 + url, data, { headers });
  }
  
  apiPostFile(url, data) {
    const headers = this.getHeaders();
    return this.http.post(this.API_URL + url, data, { headers: headers, responseType: 'blob' });
  }

  apiPatch(url, data) {
    const headers = this.getHeaders();
    return this.http.patch(this.API_URL + url, data, { headers });
  }

  apiLogin(url, data) {
    return this.http.post(this.API_URL + url, data);
  }

  apiPut(url, data) {
    const headers = this.getHeaders();
    return this.http.put(this.API_URL + url, data, { headers });
  }

  apiDelete(url, bomId?, data?) {
    const headers = this.getHeaders();
    if (bomId && bomId.length) {
      const options = {
        headers: headers,
        body: { "bomIds": bomId },
      };
      return this.http.delete(this.API_URL + url, options);
    } else {
      const payload = {headers};
      if (payload) {
        payload['body'] = data
      }
      return (payload) ? this.http.delete(this.API_URL + url, payload) : this.http.delete(this.API_URL + url, payload);
    }
  }

  msLogin(url, token){
    let headers ={
      Authorization: token
    }
    return this.http.post(this.API_URL + url,{} ,{headers});
  }

  refreshToken() {
    const refreshToken = this.localStorageGetItem('refreshToken');
    let headers = {}
    headers['Authorization'] = `Bearer ${refreshToken}`;
    return this.http.post(this.API_URL + "/auth/refreshAdminToken", {}, {headers})
  }

  localStorageSetItem(key, val) {
    let uniqueKey = this.sessionStorageGetItem('admin_role');
    key = this.encryptPipe.transform(uniqueKey + key, {"hash": true});
    val = this.encryptPipe.transform(val);
    localStorage.setItem(key, val);
  }

  localStorageGetItem(key) {
    let uniqueKey = this.sessionStorageGetItem('admin_role');
    key = this.encryptPipe.transform(uniqueKey + key, {"hash": true});
    return this.decryptPipe.transform(localStorage.getItem(key));
  }

  localStorageRemoveItem(key) {
    let uniqueKey = this.sessionStorageGetItem('admin_role');
    key = this.encryptPipe.transform(uniqueKey + key, {"hash": true});
    localStorage.removeItem(key);
  }

  sessionStorageSetItem(key, val) {
    key = this.encryptPipe.transform(key, {"hash": true});
    val = this.encryptPipe.transform(val);
    sessionStorage.setItem(key, val);
  }

  sessionStorageGetItem(key) {
    key = this.encryptPipe.transform(key, {"hash": true});
    return this.decryptPipe.transform(sessionStorage.getItem(key));
  }

  downloadImage(uri) {
    const body = {
      path: this.encryptPipe.transform(uri, {"hash": false, "key": 'authSecretKey'})
    };
    return this.apiPost(`/download/logoAndAvatar`, body);
  }

  getUserInfo(user_id, company_id) {
    let payload = {
      userId: user_id,
      companyId: company_id
    }
    return this.apiPost(`/me`, payload);

  }

  decrypt(val) {
    if (val) {
      const decrypted = CryptoJS.AES.decrypt(val, environment.authSecretKey);
      try {
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        localStorage.clear();
        sessionStorage.clear();
        location.reload();
      }
    }
    return null;
  }

  apiSendFile(url, data) {
    const headers = this.getHeaders();
    delete headers['Content-Type'];
    return this.http.post(this.API_URL + url, data, { headers });
  }
  apiGetWf(url) {
    const headers = this.getHeaders();
    return this.http.get(this.API_URL_WF + url, {headers});
  }

  apiPutWf(url, data){
    const headers = this.getHeaders();
    return this.http.put(this.API_URL_WF + url, data, { headers })
  }

 
  getCookies(key) {
    key = this.encryptPipe.transform(key, {"hash": true});
    return this.decryptPipe.transform(Cookies.get(key));
  }

  setCookies(key, val) {
    key = this.encryptPipe.transform(key, {"hash": true});
    val = this.encryptPipe.transform(val);
    Cookies.set(key, val, { expires: this.minutesToDay(environment.expiryTokenTime), domain: 'partanalytics.com' });
  }
  minutesToDay(min) {
    return min / 1440;
  }

  customerAppLogin(audit, company_id) {
    return this.apiPost(`/auth/admin-login?audit=${audit}&companyId=${company_id}`, {});
  }

  apiErrorHandler(error: HttpErrorResponse, toasterType: string, shouldShow = true, fallbackMessage: any = null, header = null, isDownloadAPI?: boolean) {
    if (shouldShow) {
      let msgKeyInError = ['msg', 'message', 'errMsg', 'errorMsg'];
      let errorMsg = '';
      msgKeyInError.forEach((key) => {
        errorMsg = (isDownloadAPI ? error[key] : error['error'][key]) || errorMsg;
      })
      if (!errorMsg.length) {
        errorMsg = fallbackMessage.length ? fallbackMessage : 'Something went wrong';
      }
      if (!error['noToaster']) {
        this.toastr[toasterType](errorMsg, header);
      }
    }
  }

  localStorageClear() {
    localStorage.clear();
  }

}
